var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{staticClass:"mb-1 mr-1",attrs:{"close":"","color":_vm.label.color,"text-color":"white","label":""},on:{"click:close":_vm.delete_clicked,"click":_vm.select}},[_vm._v(" "+_vm._s(_vm.label.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }